import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	loading: false,
	timeStamp: false,
	error: null,

	//✅ Loading States
	rolesLoadingComplete: false,
	loadingAssignRole: false,
	loadingRevokeRole: false
};

const rolesSlice = createSlice({
	name: 'roles',
	initialState,
	reducers: {
		// Load Roles
		loadRoles: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadRolesSuccess: (state, action) => {
			state.timeStamp = Date.now();
			state.loading = false;
			const orgID = action.payload.orgID;
			const oldData = state.data[orgID] || [];

			state.data[orgID] = mergeReduxStateData(oldData, action.payload.data, 'roleID');
			state.rolesLoadingComplete = true;
		},
		loadRolesError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
			state.rolesLoadingComplete = true;
		},

		// Assign Role
		assignRole: (state) => {
			state.loadingAssignRole = true;
			state.error = null;
		},
		assignRoleSuccess: (state) => {
			state.loadingAssignRole = false;
			state.error = null;
		},
		assignRoleError: (state, action) => {
			state.loadingAssignRole = false;
			state.error = action.payload;
		},

		// Revoke Role — the modal closes optimistically on dispatch; this flag only
		// drives the topbar in-flight indicator, so no success flag is needed.
		revokeRole: (state) => {
			state.loadingRevokeRole = true;
			state.error = null;
		},
		revokeRoleSuccess: (state) => {
			state.loadingRevokeRole = false;
		},
		revokeRoleError: (state, action) => {
			state.loadingRevokeRole = false;
			state.error = action.payload;
		}
	}
});

export default rolesSlice.reducer;

// Export the actions
export const roleActions = rolesSlice.actions;
